import { userEventApi } from '../apis';

async function trackUserEvent(name: string, metadata?: any) {
  return await userEventApi.addUserEvent({
    apiUserEvent: { name, metadata },
  });
}

export enum FeedbackRating {
  GOOD = 'GOOD',
  OK = 'OK',
  BAD = 'BAD',
}

export const aiInsightVersion = '1.0';

export const eventType = {
  AI_INSIGHT_FEEDBACK: 'AI_INSIGHT_FEEDBACK',
  AI_INSIGHT_CLICKED: 'AI_INSIGHT_CLICKED',
  ENTITY_SEARCH_V2: 'ENTITY_SEARCH_V2',
  TRANSACTION_SUMMARY_ALL_TIME_REQUEST: 'TRANSACTION_SUMMARY_ALL_TIME_REQUEST',
  RISK_HISTORY_CLICKED: 'RISK_HISTORY_CLICKED',
};

export const saveAiInsightClickEvent = async () => {
  return await trackUserEvent(eventType.AI_INSIGHT_CLICKED, { version: aiInsightVersion });
};

export const saveEntitySearchEvent = async (searchQuery: any) => {
  return await trackUserEvent(eventType.ENTITY_SEARCH_V2, searchQuery);
};

export const saveTransactionSummaryAllTimeEvent = async (personId: string) => {
  return await trackUserEvent(eventType.TRANSACTION_SUMMARY_ALL_TIME_REQUEST, personId);
};

export const saveRiskHistoryClickEvent = async (personId: string) => {
  return await trackUserEvent(eventType.RISK_HISTORY_CLICKED, personId);
};

export default { trackUserEvent };
